import { TMoveClientToArchiveParams } from 'types/services';
import { m8API } from 'services/production/m8';

export const moveClientToArchive = async (
  params: TMoveClientToArchiveParams
) => {
  const { clientId } = params;

  await m8API.admin.moveUserToArchive(clientId);
};
